import { FC } from 'react'

import { cn } from '@/app/utils'
import { AppButton } from '@/components/shared/button'
import { AppLoader } from '@/components/shared/loader'
import { formatRuble } from '@/utils/number'

type Props = {
  debtSum: number
  buttonText: string
  buttonLoading?: boolean
  isCommonPayment?: boolean
  onButtonClick: () => void
}

const BillsPayFooterContent: FC<Props> = ({
  debtSum,
  buttonText,
  buttonLoading,
  isCommonPayment,
  onButtonClick
}) => (
  <>
    {isCommonPayment && (
      <div className="flex flex-col sm:w-full sm:flex-row sm:items-end sm:justify-between">
        <span className="text-grey-70 text-18">Сумма к оплате</span>
        <span className="font-bold text-36 sm:text-32">
          {formatRuble(debtSum)}
        </span>
      </div>
    )}

    <AppButton
      size="large"
      className={cn(
        'ml-auto sm:!h-44 sm:w-full',
        isCommonPayment ? 'w-[200px]' : 'w-full',
        buttonLoading && 'pointer-events-none'
      )}
      onClick={onButtonClick}
    >
      {buttonLoading ? <AppLoader noText variant="primary" /> : buttonText}
    </AppButton>
  </>
)

export default BillsPayFooterContent
